<div class="nsf-modal">

	<div class="nsf-header">
		<div class="nsf-header-left">
			<span class="nsf-title">NSF / Bounced Check</span>
			<span class="nsf-check-badge" *ngIf="tran.checknum">{{ tran.checknum }}</span>
		</div>
		<button class="nsf-close-btn" (click)="close()" type="button">&times;</button>
	</div>

	<div class="nsf-body">

		<div class="nsf-payment-card">
			<div class="nsf-payment-label">Original Payment</div>
			<div class="nsf-payment-grid">
				<div class="nsf-payment-item">
					<span class="label">Customer</span>
					<span class="value">{{ tran.debtorno || tran.branchcode }}</span>
				</div>
				<div class="nsf-payment-item">
					<span class="label">Date</span>
					<span class="value">{{ tran.trandate }}</span>
				</div>
				<div class="nsf-payment-item">
					<span class="label">Method</span>
					<span class="value">{{ tran.reference }}</span>
				</div>
				<div class="nsf-payment-item">
					<span class="label">Check #</span>
					<span class="value">{{ tran.checknum || '—' }}</span>
				</div>
				<div class="nsf-payment-item nsf-payment-amount-item">
					<span class="label">Amount</span>
					<span class="value amount">{{ tran.totalamount | currency }}</span>
				</div>
			</div>
		</div>

		<div class="nsf-info-strip">
			<span class="nsf-info-icon-text">&#xe88e;</span>
			<span>Reverses the payment, re-opens allocated invoices, and adds an NSF fee charge to the customer's account.</span>
		</div>

		<div class="nsf-error" *ngIf="error">
			<span class="nsf-error-icon">&#xe000;</span>
			<span>{{ error }}</span>
		</div>

		<form [formGroup]="nsfForm" class="nsf-form" (ngSubmit)="processNsf()">

			<div class="nsf-form-row">
				<div class="nsf-input-group nsf-field-date">
					<label class="nsf-label" for="nsf-date">Posting Date</label>
					<input id="nsf-date" type="date" class="nsf-input" formControlName="date">
				</div>

				<div class="nsf-input-group nsf-field-fee">
					<label class="nsf-label" for="nsf-fee">NSF Fee</label>
					<div class="nsf-input-prefix-wrap">
						<span class="nsf-prefix">$</span>
						<input id="nsf-fee" type="number" class="nsf-input nsf-input-has-prefix" formControlName="feeAmount" step="0.01" min="0">
					</div>
				</div>
			</div>

			<div class="nsf-input-group nsf-gl-wrapper">
				<label class="nsf-label" for="nsf-gl">GL Account</label>
				<input id="nsf-gl" type="text" class="nsf-input"
					formControlName="glAccount"
					(input)="onGlInput($event.target.value)"
					(focus)="onGlFocus()"
					(blur)="onGlBlur()"
					placeholder="Search account code or name"
					autocomplete="off">
				<div class="nsf-gl-dropdown" *ngIf="glDropdownOpen && glAccounts.length > 0">
					<div class="nsf-gl-option"
						*ngFor="let acct of glAccounts | slice:0:50"
						(mousedown)="selectGlAccount(acct)">
						<span class="nsf-gl-code">{{ acct.accountcode }}</span>
						<span class="nsf-gl-name">{{ acct.accountname }}</span>
					</div>
				</div>
				<span class="nsf-hint">Income account for NSF fee posting</span>
			</div>

			<div class="nsf-input-group">
				<label class="nsf-label" for="nsf-reason">Reason</label>
				<textarea id="nsf-reason" class="nsf-input nsf-textarea" formControlName="reason" rows="2" placeholder="Reason for NSF reversal"></textarea>
			</div>

		</form>

	</div>

	<div class="nsf-actions">
		<button class="nsf-btn nsf-btn-cancel" (click)="close()" [disabled]="processing" type="button">Cancel</button>
		<button class="nsf-btn nsf-btn-submit" (click)="processNsf()" [disabled]="!nsfForm.valid || processing" type="button">
			<ng-container *ngIf="!processing">Process NSF</ng-container>
			<ng-container *ngIf="processing">
				<svg class="nsf-spinner" width="18" height="18" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
					<circle fill="none" stroke-width="7" stroke-linecap="round" cx="33" cy="33" r="30" class="nsf-spinner-circle"></circle>
				</svg>
				Processing...
			</ng-container>
		</button>
	</div>

</div>
